import { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

const TIPO_LABEL = {
  pop: 'POP', manual: 'Manual', descricao_cargo: 'Descrição de cargo',
  informativo: 'Informativo', treinamento_video: 'Treinamento', cultura: 'Cultura', ata: 'Ata',
};
const TIPO_ICONE = {
  pop: 'bi-card-checklist', manual: 'bi-journal-text', descricao_cargo: 'bi-person-badge',
  informativo: 'bi-info-circle', treinamento_video: 'bi-play-btn-fill', cultura: 'bi-heart', ata: 'bi-file-earmark-text',
};

function formatarData(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
}

export default function Documentos() {
  const { temPermissao } = useAuth();
  const podeEditar = temPermissao('editar_documento');
  const [categorias, setCategorias] = useState([]);
  const [docs, setDocs] = useState([]);
  const [cat, setCat] = useState('');
  const [busca, setBusca] = useState('');
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    api.get('/categorias').then(({ data }) => setCategorias(data.categorias)).catch(() => {});
  }, []);

  const carregar = useCallback(async (categoria, termo) => {
    setCarregando(true);
    try {
      const params = {};
      if (categoria) params.categoria = categoria;
      if (termo && termo.trim()) params.busca = termo.trim();
      const { data } = await api.get('/documentos', { params });
      setDocs(data.documentos);
    } catch (_) {
      setDocs([]);
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { carregar(cat, busca); /* eslint-disable-next-line */ }, [cat]);

  function buscar(e) {
    e.preventDefault();
    carregar(cat, busca);
  }

  return (
    <>
      <Header />
      <main className="conteudo-container">
        <Link to="/documentos" className="doc-voltar"><i className="bi bi-arrow-left"></i> Documentos</Link>
        <div className="doc-topo">
          <div>
            <h1 style={{ color: 'var(--verde)', fontWeight: 700, marginBottom: 4 }}>Documentos</h1>
            <p style={{ color: 'var(--texto-suave)', margin: 0 }}>Manuais, POPs e materiais do seu cargo.</p>
          </div>
          {podeEditar && (
            <Link to="/admin/documentos/novo" className="btn-centrao">
              <i className="bi bi-plus-lg me-1"></i> Novo documento
            </Link>
          )}
        </div>

        <form className="doc-busca" onSubmit={buscar}>
          <i className="bi bi-search"></i>
          <input
            type="text"
            placeholder="Buscar por título ou resumo…"
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
          />
          {busca && <button type="button" className="doc-busca-limpar" onClick={() => { setBusca(''); carregar(cat, ''); }}>×</button>}
        </form>

        <div className="doc-chips">
          <button className={`doc-chip${cat === '' ? ' doc-chip--ativo' : ''}`} onClick={() => setCat('')}>Todas</button>
          {categorias.filter(c => c.qtd_docs > 0).map(c => (
            <button key={c.id} className={`doc-chip${cat === c.slug ? ' doc-chip--ativo' : ''}`} onClick={() => setCat(c.slug)}>
              {c.icone && <i className={`bi ${c.icone}`}></i>} {c.nome}
              <span className="doc-chip-qtd">{c.qtd_docs}</span>
            </button>
          ))}
        </div>

        {carregando && <div>Carregando…</div>}

        {!carregando && docs.length === 0 && (
          <div className="conteudo-card" style={{ textAlign: 'center', padding: '40px 16px' }}>
            <i className="bi bi-folder2-open" style={{ fontSize: '2.5rem', color: 'var(--texto-suave)' }}></i>
            <p style={{ color: 'var(--texto-suave)', marginTop: 12 }}>Nenhum documento por aqui ainda.</p>
          </div>
        )}

        <div className="doc-grid">
          {docs.map(d => (
            <Link key={d.id} to={`/documentos/${d.id}`} className="doc-card">
              <div className="doc-card-icone"><i className={`bi ${TIPO_ICONE[d.tipo] || 'bi-file-earmark-text'}`}></i></div>
              <div className="doc-card-corpo">
                <div className="doc-card-tipo">{TIPO_LABEL[d.tipo] || d.tipo}{d.categoria_nome ? ` · ${d.categoria_nome}` : ''}</div>
                <div className="doc-card-titulo">{d.titulo}</div>
                {d.resumo && <div className="doc-card-resumo">{d.resumo}</div>}
                <div className="doc-card-rodape">
                  <span>{formatarData(d.data_publicacao)}</span>
                  {d.obriga_marcacao_leitura
                    ? (d.lido
                        ? <span className="doc-badge doc-badge--ok"><i className="bi bi-check-circle-fill"></i> Lido</span>
                        : <span className="doc-badge doc-badge--pend"><i className="bi bi-exclamation-circle"></i> Leitura obrigatória</span>)
                    : null}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </main>
    </>
  );
}
